import styled from '@emotion/styled';

const SubtopicsWrapper = styled('section')({
  maxHeight: 540,
  overflowY: 'auto'
});

export default SubtopicsWrapper;
